var COUNTRIES = [
	{
		"COUNTRY": "AFGHANISTAN",
		"PAESE": "AFGHANISTAN",
		"ISO_3166": "AF",
		"CODE": "+93",
		"LABEL": "AFGHANISTAN (+93)",
		"LABEL_ITA": "AFGHANISTAN (+93)"
	},
	{
		"COUNTRY": "ALBANIA",
		"PAESE": "ALBANIA",
		"ISO_3166": "AL",
		"CODE": "+355",
		"LABEL": "ALBANIA (+355)",
		"LABEL_ITA": "ALBANIA (+355)"
	},
	{
		"COUNTRY": "ALGERIA",
		"PAESE": "ALGERIA",
		"ISO_3166": "DZ",
		"CODE": "+213",
		"LABEL": "ALGERIA (+213)",
		"LABEL_ITA": "ALGERIA (+213)"
	},
	{
		"COUNTRY": "AMERICAN SAMOA",
		"PAESE": "SAMOA AMERICANE",
		"ISO_3166": "AS",
		"CODE": "+685",
		"LABEL": "AMERICAN SAMOA (+685)",
		"LABEL_ITA": "SAMOA AMERICANE (+685)"
	},
	{
		"COUNTRY": "ANDORRA",
		"PAESE": "ANDORRA",
		"ISO_3166": "AD",
		"CODE": "+376",
		"LABEL": "ANDORRA (+376)",
		"LABEL_ITA": "ANDORRA (+376)"
	},
	{
		"COUNTRY": "ANGOLA",
		"PAESE": "ANGOLA",
		"ISO_3166": "AO",
		"CODE": "+244",
		"LABEL": "ANGOLA (+244)",
		"LABEL_ITA": "ANGOLA (+244)"
	},
	{
		"COUNTRY": "ANGUILLA",
		"PAESE": "ANGUILLA",
		"ISO_3166": "AI",
		"CODE": "+1264",
		"LABEL": "ANGUILLA (+1264)",
		"LABEL_ITA": "ANGUILLA (+1264)"
	},
	{
		"COUNTRY": "ANTIGUA",
		"PAESE": "ANTIGUA E BARBUDA",
		"ISO_3166": "AG",
		"CODE": "+1268",
		"LABEL": "ANTIGUA (+1268)",
		"LABEL_ITA": "ANTIGUA E BARBUDA (+1268)"
	},
	{
		"COUNTRY": "ARGENTINA",
		"PAESE": "ARGENTINA",
		"ISO_3166": "AR",
		"CODE": "+54",
		"LABEL": "ARGENTINA (+54)",
		"LABEL_ITA": "ARGENTINA (+54)"
	},
	{
		"COUNTRY": "ARMENIA",
		"PAESE": "ARMENIA",
		"ISO_3166": "AM",
		"CODE": "+374",
		"LABEL": "ARMENIA (+374)",
		"LABEL_ITA": "ARMENIA (+374)"
	},
	{
		"COUNTRY": "ARUBA",
		"PAESE": "ARUBA",
		"ISO_3166": "AW",
		"CODE": "+297",
		"LABEL": "ARUBA (+297)",
		"LABEL_ITA": "ARUBA (+297)"
	},
	{
		"COUNTRY": "ASCENSION",
		"PAESE": "ASCENSION",
		"ISO_3166": "SH",
		"CODE": "+247",
		"LABEL": "ASCENSION (+247)",
		"LABEL_ITA": "ASCENSION (+247)"
	},
	{
		"COUNTRY": "AUSTRALIA",
		"PAESE": "AUSTRALIA",
		"ISO_3166": "AU",
		"CODE": "+61",
		"LABEL": "AUSTRALIA (+61)",
		"LABEL_ITA": "AUSTRALIA (+61)"
	},
	{
		"COUNTRY": "AUSTRIA",
		"PAESE": "AUSTRIA",
		"ISO_3166": "AT",
		"CODE": "+43",
		"LABEL": "AUSTRIA (+43)",
		"LABEL_ITA": "AUSTRIA (+43)"
	},
	{
		"COUNTRY": "AZERBAIJAN",
		"PAESE": "ARZEBAIGIAN",
		"ISO_3166": "AZ",
		"CODE": "+994",
		"LABEL": "AZERBAIJAN (+994)",
		"LABEL_ITA": "ARZEBAIGIAN (+994)"
	},
	{
		"COUNTRY": "BAHAMAS, THE",
		"PAESE": "BAHAMAS",
		"ISO_3166": "BS",
		"CODE": "+1242",
		"LABEL": "BAHAMAS, THE (+1242)",
		"LABEL_ITA": "BAHAMAS (+1242)"
	},
	{
		"COUNTRY": "BAHRAIN",
		"PAESE": "BAHREIN",
		"ISO_3166": "BH",
		"CODE": "+973",
		"LABEL": "BAHRAIN (+973)",
		"LABEL_ITA": "BAHREIN (+973)"
	},
	{
		"COUNTRY": "BANGLADESH",
		"PAESE": "BANGLADESH",
		"ISO_3166": "BD",
		"CODE": "+880",
		"LABEL": "BANGLADESH (+880)",
		"LABEL_ITA": "BANGLADESH (+880)"
	},
	{
		"COUNTRY": "BARBADOS",
		"PAESE": "BARBADOS",
		"ISO_3166": "BB",
		"CODE": "+1246",
		"LABEL": "BARBADOS (+1246)",
		"LABEL_ITA": "BARBADOS (+1246)"
	},
	{
		"COUNTRY": "BELARUS",
		"PAESE": "BIELORUSSIA",
		"ISO_3166": "BY",
		"CODE": "+375",
		"LABEL": "BELARUS (+375)",
		"LABEL_ITA": "BIELORUSSIA (+375)"
	},
	{
		"COUNTRY": "BELGIUM",
		"PAESE": "BELGIO",
		"ISO_3166": "BE",
		"CODE": "+32",
		"LABEL": "BELGIUM (+32)",
		"LABEL_ITA": "BELGIO (+32)"
	},
	{
		"COUNTRY": "BELIZE",
		"PAESE": "BELIZE",
		"ISO_3166": "BZ",
		"CODE": "+501",
		"LABEL": "BELIZE (+501)",
		"LABEL_ITA": "BELIZE (+501)"
	},
	{
		"COUNTRY": "BENIN",
		"PAESE": "BENIN",
		"ISO_3166": "BJ",
		"CODE": "+229",
		"LABEL": "BENIN (+229)",
		"LABEL_ITA": "BENIN (+229)"
	},
	{
		"COUNTRY": "BERMUDA",
		"PAESE": "BERMUDA",
		"ISO_3166": "BM",
		"CODE": "+1441",
		"LABEL": "BERMUDA (+1441)",
		"LABEL_ITA": "BERMUDA (+1441)"
	},
	{
		"COUNTRY": "BHUTAN",
		"PAESE": "BHUTAN",
		"ISO_3166": "BT",
		"CODE": "+975",
		"LABEL": "BHUTAN (+975)",
		"LABEL_ITA": "BHUTAN (+975)"
	},
	{
		"COUNTRY": "BOLIVIA",
		"PAESE": "BOLIVIA",
		"ISO_3166": "BO",
		"CODE": "+591",
		"LABEL": "BOLIVIA (+591)",
		"LABEL_ITA": "BOLIVIA (+591)"
	},
	{
		"COUNTRY": "BOSNIA ED ERZEGOVINA",
		"PAESE": "BOSNIA-ERZEGOVINA",
		"ISO_3166": "BA",
		"CODE": "+387",
		"LABEL": "BOSNIA ED ERZEGOVINA (+387)",
		"LABEL_ITA": "BOSNIA-ERZEGOVINA (+387)"
	},
	{
		"COUNTRY": "BOTSWANA",
		"PAESE": "BOTSWANA",
		"ISO_3166": "BW",
		"CODE": "+267",
		"LABEL": "BOTSWANA (+267)",
		"LABEL_ITA": "BOTSWANA (+267)"
	},
	{
		"COUNTRY": "BOUVET ISLAND",
		"PAESE": "BOUVET",
		"ISO_3166": "BV",
		"CODE": "+55",
		"LABEL": "BOUVET ISLAND (+55)",
		"LABEL_ITA": "BOUVET (+55)"
	},
	{
		"COUNTRY": "BRAZIL",
		"PAESE": "BRASILE",
		"ISO_3166": "BR",
		"CODE": "+55",
		"LABEL": "BRAZIL (+55)",
		"LABEL_ITA": "BRASILE (+55)"
	},
	{
		"COUNTRY": "BRITISH INDIAN OCEAN TERRITORY",
		"PAESE": "TERRITORI BRITANNICI D'OLTREMARE",
		"ISO_3166": "IO",
		"CODE": "+246",
		"LABEL": "BRITISH INDIAN OCEAN TERRITORY (+246)",
		"LABEL_ITA": "TERRITORI BRITANNICI D'OLTREMARE (+246)"
	},
	{
		"COUNTRY": "BRUNEI",
		"PAESE": "BRUNEI",
		"ISO_3166": "BN",
		"CODE": "+673",
		"LABEL": "BRUNEI (+673)",
		"LABEL_ITA": "BRUNEI (+673)"
	},
	{
		"COUNTRY": "BULGARIA",
		"PAESE": "BULGARIA",
		"ISO_3166": "BG",
		"CODE": "+359",
		"LABEL": "BULGARIA (+359)",
		"LABEL_ITA": "BULGARIA (+359)"
	},
	{
		"COUNTRY": "BURKINA FASO",
		"PAESE": "BURKINA FASO",
		"ISO_3166": "BF",
		"CODE": "+226",
		"LABEL": "BURKINA FASO (+226)",
		"LABEL_ITA": "BURKINA FASO (+226)"
	},
	{
		"COUNTRY": "BURUNDI",
		"PAESE": "BURUNDI",
		"ISO_3166": "BI",
		"CODE": "+257",
		"LABEL": "BURUNDI (+257)",
		"LABEL_ITA": "BURUNDI (+257)"
	},
	{
		"COUNTRY": "CAMBODIA",
		"PAESE": "CAMBOGIA",
		"ISO_3166": "KH",
		"CODE": "+855",
		"LABEL": "CAMBODIA (+855)",
		"LABEL_ITA": "CAMBOGIA (+855)"
	},
	{
		"COUNTRY": "CAMEROON",
		"PAESE": "CAMERUN",
		"ISO_3166": "CM",
		"CODE": "+237",
		"LABEL": "CAMEROON (+237)",
		"LABEL_ITA": "CAMERUN (+237)"
	},
	{
		"COUNTRY": "CANADA",
		"PAESE": "CANADA",
		"ISO_3166": "CA",
		"CODE": "+1",
		"LABEL": "CANADA (+1)",
		"LABEL_ITA": "CANADA (+1)"
	},
	{
		"COUNTRY": "CAPE VERDE",
		"PAESE": "CAPO VERDE",
		"ISO_3166": "CV",
		"CODE": "+238",
		"LABEL": "CAPE VERDE (+238)",
		"LABEL_ITA": "CAPO VERDE (+238)"
	},
	{
		"COUNTRY": "CAYMAN ISLANDS",
		"PAESE": "CAYMAN",
		"ISO_3166": "KY",
		"CODE": "+1345",
		"LABEL": "CAYMAN ISLANDS (+1345)",
		"LABEL_ITA": "CAYMAN (+1345)"
	},
	{
		"COUNTRY": "CENTRAL AFRICAN R.",
		"PAESE": "CENTRAFRICANA REPUBBLICA",
		"ISO_3166": "CF",
		"CODE": "+236",
		"LABEL": "CENTRAL AFRICAN R. (+236)",
		"LABEL_ITA": "CENTRAFRICANA REPUBBLICA (+236)"
	},
	{
		"COUNTRY": "CHAD",
		"PAESE": "CIAD",
		"ISO_3166": "TD",
		"CODE": "+235",
		"LABEL": "CHAD (+235)",
		"LABEL_ITA": "CIAD (+235)"
	},
	{
		"COUNTRY": "CHILE",
		"PAESE": "CILE",
		"ISO_3166": "CL",
		"CODE": "+56",
		"LABEL": "CHILE (+56)",
		"LABEL_ITA": "CILE (+56)"
	},
	{
		"COUNTRY": "CHINA",
		"PAESE": "CINA",
		"ISO_3166": "CN",
		"CODE": "+86",
		"LABEL": "CHINA (+86)",
		"LABEL_ITA": "CINA (+86)"
	},
	{
		"COUNTRY": "CHRISTMAS ISLAND",
		"PAESE": "ISOLA DI NATALE",
		"ISO_3166": "CX",
		"CODE": "+61",
		"LABEL": "CHRISTMAS ISLAND (+61)",
		"LABEL_ITA": "ISOLA DI NATALE (+61)"
	},
	{
		"COUNTRY": "COCOS (KEELING) ISLANDS",
		"PAESE": "ISOLE COCOS (KEELING)",
		"ISO_3166": "CC",
		"CODE": "+61",
		"LABEL": "COCOS (KEELING) ISLANDS (+61)",
		"LABEL_ITA": "ISOLE COCOS (KEELING) (+61)"
	},
	{
		"COUNTRY": "COLOMBIA",
		"PAESE": "COLOMBIA",
		"ISO_3166": "CO",
		"CODE": "+57",
		"LABEL": "COLOMBIA (+57)",
		"LABEL_ITA": "COLOMBIA (+57)"
	},
	{
		"COUNTRY": "COMOROS",
		"PAESE": "COMORE",
		"ISO_3166": "KM",
		"CODE": "+269",
		"LABEL": "COMOROS (+269)",
		"LABEL_ITA": "COMORE (+269)"
	},
	{
		"COUNTRY": "CONGO",
		"PAESE": "CONGO",
		"ISO_3166": "CG",
		"CODE": "+243",
		"LABEL": "CONGO (+243)",
		"LABEL_ITA": "CONGO (+243)"
	},
	{
		"COUNTRY": "COOK ISLANDS",
		"PAESE": "COOK",
		"ISO_3166": "CK",
		"CODE": "+682",
		"LABEL": "COOK ISLANDS (+682)",
		"LABEL_ITA": "COOK (+682)"
	},
	{
		"COUNTRY": "COSTA RICA",
		"PAESE": "COSTA RICA",
		"ISO_3166": "CR",
		"CODE": "+506",
		"LABEL": "COSTA RICA (+506)",
		"LABEL_ITA": "COSTA RICA (+506)"
	},
	{
		"COUNTRY": "COTE D'IVOIRE",
		"PAESE": "COSTA D'AVORIO",
		"ISO_3166": "CI",
		"CODE": "+225",
		"LABEL": "COTE D'IVOIRE (+225)",
		"LABEL_ITA": "COSTA D'AVORIO (+225)"
	},
	{
		"COUNTRY": "CROATIA",
		"PAESE": "CROAZIA",
		"ISO_3166": "HR",
		"CODE": "+385",
		"LABEL": "CROATIA (+385)",
		"LABEL_ITA": "CROAZIA (+385)"
	},
	{
		"COUNTRY": "CUBA",
		"PAESE": "CUBA",
		"ISO_3166": "CU",
		"CODE": "+53",
		"LABEL": "CUBA (+53)",
		"LABEL_ITA": "CUBA (+53)"
	},
	{
		"COUNTRY": "CYPRUS",
		"PAESE": "CIPRO",
		"ISO_3166": "CY",
		"CODE": "+357",
		"LABEL": "CYPRUS (+357)",
		"LABEL_ITA": "CIPRO (+357)"
	},
	{
		"COUNTRY": "CZECH REPUBLIC",
		"PAESE": "CECA REPUBBLICA",
		"ISO_3166": "CZ",
		"CODE": "+420",
		"LABEL": "CZECH REPUBLIC (+420)",
		"LABEL_ITA": "CECA REPUBBLICA (+420)"
	},
	{
		"COUNTRY": "DENMARK",
		"PAESE": "DANIMARCA",
		"ISO_3166": "DK",
		"CODE": "+45",
		"LABEL": "DENMARK (+45)",
		"LABEL_ITA": "DANIMARCA (+45)"
	},
	{
		"COUNTRY": "DJIBOUTI",
		"PAESE": "GIBUTI",
		"ISO_3166": "DJ",
		"CODE": "+253",
		"LABEL": "DJIBOUTI (+253)",
		"LABEL_ITA": "GIBUTI (+253)"
	},
	{
		"COUNTRY": "DOMINICA",
		"PAESE": "DOMINICA",
		"ISO_3166": "DM",
		"CODE": "+1767",
		"LABEL": "DOMINICA (+1767)",
		"LABEL_ITA": "DOMINICA (+1767)"
	},
	{
		"COUNTRY": "DOMINICAN REPUBLIC",
		"PAESE": "DOMINICANA REPUBBLICA",
		"ISO_3166": "DO",
		"CODE": "+1809",
		"LABEL": "DOMINICAN REPUBLIC (+1809)",
		"LABEL_ITA": "DOMINICANA REPUBBLICA (+1809)"
	},
	{
		"COUNTRY": "ECUADOR",
		"PAESE": "ECUADOR",
		"ISO_3166": "EC",
		"CODE": "+593",
		"LABEL": "ECUADOR (+593)",
		"LABEL_ITA": "ECUADOR (+593)"
	},
	{
		"COUNTRY": "EGYPT",
		"PAESE": "EGITTO",
		"ISO_3166": "EG",
		"CODE": "+20",
		"LABEL": "EGYPT (+20)",
		"LABEL_ITA": "EGITTO (+20)"
	},
	{
		"COUNTRY": "EL SALVADOR",
		"PAESE": "EL SALVADOR",
		"ISO_3166": "SV",
		"CODE": "+503",
		"LABEL": "EL SALVADOR (+503)",
		"LABEL_ITA": "EL SALVADOR (+503)"
	},
	{
		"COUNTRY": "EQUATORIAL GUINEA",
		"PAESE": "GUINEA EQUATORIALE",
		"ISO_3166": "GQ",
		"CODE": "+240",
		"LABEL": "EQUATORIAL GUINEA (+240)",
		"LABEL_ITA": "GUINEA EQUATORIALE (+240)"
	},
	{
		"COUNTRY": "ERITREA",
		"PAESE": "ERITREA",
		"ISO_3166": "ER",
		"CODE": "+291",
		"LABEL": "ERITREA (+291)",
		"LABEL_ITA": "ERITREA (+291)"
	},
	{
		"COUNTRY": "ESTONIA",
		"PAESE": "ESTONIA",
		"ISO_3166": "EE",
		"CODE": "+372",
		"LABEL": "ESTONIA (+372)",
		"LABEL_ITA": "ESTONIA (+372)"
	},
	{
		"COUNTRY": "ETHIOPIA",
		"PAESE": "ETIOPIA",
		"ISO_3166": "ET",
		"CODE": "+251",
		"LABEL": "ETHIOPIA (+251)",
		"LABEL_ITA": "ETIOPIA (+251)"
	},
	{
		"COUNTRY": "FALKLAND ISLANDS (MALVINAS)",
		"PAESE": "FALKLAND",
		"ISO_3166": "FK",
		"CODE": "+500",
		"LABEL": "FALKLAND ISLANDS (MALVINAS) (+500)",
		"LABEL_ITA": "FALKLAND (+500)"
	},
	{
		"COUNTRY": "FAROE ISLANDS",
		"PAESE": "FAEROER",
		"ISO_3166": "FO",
		"CODE": "+298",
		"LABEL": "FAROE ISLANDS (+298)",
		"LABEL_ITA": "FAEROER (+298)"
	},
	{
		"COUNTRY": "FIJI",
		"PAESE": "FIGI",
		"ISO_3166": "FJ",
		"CODE": "+679",
		"LABEL": "FIJI (+679)",
		"LABEL_ITA": "FIGI (+679)"
	},
	{
		"COUNTRY": "FINLAND",
		"PAESE": "FINLANDIA",
		"ISO_3166": "FI",
		"CODE": "+358",
		"LABEL": "FINLAND (+358)",
		"LABEL_ITA": "FINLANDIA (+358)"
	},
	{
		"COUNTRY": "FRANCE",
		"PAESE": "FRANCIA",
		"ISO_3166": "FR",
		"CODE": "+33",
		"LABEL": "FRANCE (+33)",
		"LABEL_ITA": "FRANCIA (+33)"
	},
	{
		"COUNTRY": "FRENCH GUIANA",
		"PAESE": "GUYANA FRANCESE",
		"ISO_3166": "GY",
		"CODE": "+594",
		"LABEL": "FRENCH GUIANA (+594)",
		"LABEL_ITA": "GUYANA FRANCESE (+594)"
	},
	{
		"COUNTRY": "FRENCH POLYNESIA",
		"PAESE": "POLINESIA FRANCESE",
		"ISO_3166": "PF",
		"CODE": "+689",
		"LABEL": "FRENCH POLYNESIA (+689)",
		"LABEL_ITA": "POLINESIA FRANCESE (+689)"
	},
	{
		"COUNTRY": "FRENCH SOUTHERN TERRITORIES",
		"PAESE": "TERRE AUSTRALI E ANTARTICHE FRANCESI",
		"ISO_3166": "TF",
		"CODE": "+262",
		"LABEL": "FRENCH SOUTHERN TERRITORIES (+262)",
		"LABEL_ITA": "TERRE AUSTRALI E ANTARTICHE FRANCESI (+262)"
	},
	{
		"COUNTRY": "GABON",
		"PAESE": "GABON",
		"ISO_3166": "GA",
		"CODE": "+241",
		"LABEL": "GABON (+241)",
		"LABEL_ITA": "GABON (+241)"
	},
	{
		"COUNTRY": "GAMBIA",
		"PAESE": "THE,GAMBIA",
		"ISO_3166": "GM",
		"CODE": "+220",
		"LABEL": "GAMBIA (+220)",
		"LABEL_ITA": "THE,GAMBIA (+220)"
	},
	{
		"COUNTRY": "GEORGIA",
		"PAESE": "GEORGIA",
		"ISO_3166": "GE",
		"CODE": "+995",
		"LABEL": "GEORGIA (+995)",
		"LABEL_ITA": "GEORGIA (+995)"
	},
	{
		"COUNTRY": "GERMANY",
		"PAESE": "GERMANIA",
		"ISO_3166": "DE",
		"CODE": "+49",
		"LABEL": "GERMANY (+49)",
		"LABEL_ITA": "GERMANIA (+49)"
	},
	{
		"COUNTRY": "GHANA",
		"PAESE": "GHANA",
		"ISO_3166": "GH",
		"CODE": "+233",
		"LABEL": "GHANA (+233)",
		"LABEL_ITA": "GHANA (+233)"
	},
	{
		"COUNTRY": "GIBRALTAR",
		"PAESE": "GIBILTERRA",
		"ISO_3166": "GI",
		"CODE": "+350",
		"LABEL": "GIBRALTAR (+350)",
		"LABEL_ITA": "GIBILTERRA (+350)"
	},
	{
		"COUNTRY": "GREECE",
		"PAESE": "GRECIA",
		"ISO_3166": "GR",
		"CODE": "+30",
		"LABEL": "GREECE (+30)",
		"LABEL_ITA": "GRECIA (+30)"
	},
	{
		"COUNTRY": "GREENLAND",
		"PAESE": "GROENLANDIA",
		"ISO_3166": "GL",
		"CODE": "+299",
		"LABEL": "GREENLAND (+299)",
		"LABEL_ITA": "GROENLANDIA (+299)"
	},
	{
		"COUNTRY": "GRENADA",
		"PAESE": "GRENADA",
		"ISO_3166": "GD",
		"CODE": "+1473",
		"LABEL": "GRENADA (+1473)",
		"LABEL_ITA": "GRENADA (+1473)"
	},
	{
		"COUNTRY": "GUADELOUPE",
		"PAESE": "GUADALUPA",
		"ISO_3166": "GP",
		"CODE": "+590",
		"LABEL": "GUADELOUPE (+590)",
		"LABEL_ITA": "GUADALUPA (+590)"
	},
	{
		"COUNTRY": "GUAM",
		"PAESE": "GUAM",
		"ISO_3166": "GU",
		"CODE": "+16",
		"LABEL": "GUAM (+16)",
		"LABEL_ITA": "GUAM (+16)"
	},
	{
		"COUNTRY": "GUATEMALA",
		"PAESE": "GUATEMALA",
		"ISO_3166": "GT",
		"CODE": "+502",
		"LABEL": "GUATEMALA (+502)",
		"LABEL_ITA": "GUATEMALA (+502)"
	},
	{
		"COUNTRY": "GUINEA",
		"PAESE": "GUINEA REPUBBLICA",
		"ISO_3166": "GN",
		"CODE": "+224",
		"LABEL": "GUINEA (+224)",
		"LABEL_ITA": "GUINEA REPUBBLICA (+224)"
	},
	{
		"COUNTRY": "GUINEA-BISSAU",
		"PAESE": "GUINEA BISSAU",
		"ISO_3166": "GW",
		"CODE": "+245",
		"LABEL": "GUINEA-BISSAU (+245)",
		"LABEL_ITA": "GUINEA BISSAU (+245)"
	},
	{
		"COUNTRY": "GUYANA",
		"PAESE": "GUYANA",
		"ISO_3166": "GY",
		"CODE": "+592",
		"LABEL": "GUYANA (+592)",
		"LABEL_ITA": "GUYANA (+592)"
	},
	{
		"COUNTRY": "HAITI",
		"PAESE": "HAITI",
		"ISO_3166": "HT",
		"CODE": "+509",
		"LABEL": "HAITI (+509)",
		"LABEL_ITA": "HAITI (+509)"
	},
	{
		"COUNTRY": "HAWAII",
		"PAESE": "HAWAII",
		"ISO_3166": "US",
		"CODE": "+18",
		"LABEL": "HAWAII (+18)",
		"LABEL_ITA": "HAWAII (+18)"
	},
	{
		"COUNTRY": "HEARD ISLAND AND MCDONALD ISLANDS",
		"PAESE": "ISOLE HEARD E MCDONALD",
		"ISO_3166": "HM",
		"CODE": "+0",
		"LABEL": "HEARD ISLAND AND MCDONALD ISLANDS (+0)",
		"LABEL_ITA": "ISOLE HEARD E MCDONALD (+0)"
	},
	{
		"COUNTRY": "HOLY SEE",
		"PAESE": "VATICANO",
		"ISO_3166": "VA",
		"CODE": "+39",
		"LABEL": "HOLY SEE (+39)",
		"LABEL_ITA": "VATICANO (+39)"
	},
	{
		"COUNTRY": "HONDURAS",
		"PAESE": "HONDURAS",
		"ISO_3166": "HN",
		"CODE": "+504",
		"LABEL": "HONDURAS (+504)",
		"LABEL_ITA": "HONDURAS (+504)"
	},
	{
		"COUNTRY": "HONG KONG",
		"PAESE": "HONG KONG",
		"ISO_3166": "HK",
		"CODE": "+852",
		"LABEL": "HONG KONG (+852)",
		"LABEL_ITA": "HONG KONG (+852)"
	},
	{
		"COUNTRY": "HUNGARY",
		"PAESE": "UNGHERIA",
		"ISO_3166": "HU",
		"CODE": "+36",
		"LABEL": "HUNGARY (+36)",
		"LABEL_ITA": "UNGHERIA (+36)"
	},
	{
		"COUNTRY": "ICELAND",
		"PAESE": "ISLANDA",
		"ISO_3166": "IS",
		"CODE": "+354",
		"LABEL": "ICELAND (+354)",
		"LABEL_ITA": "ISLANDA (+354)"
	},
	{
		"COUNTRY": "INDIA",
		"PAESE": "INDIA",
		"ISO_3166": "IN",
		"CODE": "+91",
		"LABEL": "INDIA (+91)",
		"LABEL_ITA": "INDIA (+91)"
	},
	{
		"COUNTRY": "INDONESIA",
		"PAESE": "INDONESIA",
		"ISO_3166": "ID",
		"CODE": "+62",
		"LABEL": "INDONESIA (+62)",
		"LABEL_ITA": "INDONESIA (+62)"
	},
	{
		"COUNTRY": "IRAN",
		"PAESE": "IRAN",
		"ISO_3166": "IR",
		"CODE": "+98",
		"LABEL": "IRAN (+98)",
		"LABEL_ITA": "IRAN (+98)"
	},
	{
		"COUNTRY": "IRAQ",
		"PAESE": "IRAQ",
		"ISO_3166": "IQ",
		"CODE": "+964",
		"LABEL": "IRAQ (+964)",
		"LABEL_ITA": "IRAQ (+964)"
	},
	{
		"COUNTRY": "IRELAND",
		"PAESE": "IRLANDA",
		"ISO_3166": "IE",
		"CODE": "+353",
		"LABEL": "IRELAND (+353)",
		"LABEL_ITA": "IRLANDA (+353)"
	},
	{
		"COUNTRY": "ISRAEL",
		"PAESE": "ISRAELE",
		"ISO_3166": "IL",
		"CODE": "+972",
		"LABEL": "ISRAEL (+972)",
		"LABEL_ITA": "ISRAELE (+972)"
	},
	{
		"COUNTRY": "ITALY",
		"PAESE": "ITALIA",
		"ISO_3166": "IT",
		"CODE": "+39",
		"LABEL": "ITALY (+39)",
		"LABEL_ITA": "ITALIA (+39)"
	},
	{
		"COUNTRY": "JAMAICA",
		"PAESE": "GIAMAICA",
		"ISO_3166": "JM",
		"CODE": "+1876",
		"LABEL": "JAMAICA (+1876)",
		"LABEL_ITA": "GIAMAICA (+1876)"
	},
	{
		"COUNTRY": "JAPAN",
		"PAESE": "GIAPPONE",
		"ISO_3166": "JP",
		"CODE": "+81",
		"LABEL": "JAPAN (+81)",
		"LABEL_ITA": "GIAPPONE (+81)"
	},
	{
		"COUNTRY": "JORDAN",
		"PAESE": "GIORDANIA",
		"ISO_3166": "JO",
		"CODE": "+962",
		"LABEL": "JORDAN (+962)",
		"LABEL_ITA": "GIORDANIA (+962)"
	},
	{
		"COUNTRY": "KAZAKHSTAN",
		"PAESE": "KAZAKISTAN",
		"ISO_3166": "KZ",
		"CODE": "+7",
		"LABEL": "KAZAKHSTAN (+7)",
		"LABEL_ITA": "KAZAKISTAN (+7)"
	},
	{
		"COUNTRY": "KENYA",
		"PAESE": "KENYA",
		"ISO_3166": "KE",
		"CODE": "+254",
		"LABEL": "KENYA (+254)",
		"LABEL_ITA": "KENYA (+254)"
	},
	{
		"COUNTRY": "KIRIBATI",
		"PAESE": "KIRIBATI",
		"ISO_3166": "KI",
		"CODE": "+686",
		"LABEL": "KIRIBATI (+686)",
		"LABEL_ITA": "KIRIBATI (+686)"
	},
	{
		"COUNTRY": "KOREA, NORTH",
		"PAESE": "COREA DEL NORD",
		"ISO_3166": "KP",
		"CODE": "+850",
		"LABEL": "KOREA, NORTH (+850)",
		"LABEL_ITA": "COREA DEL NORD (+850)"
	},
	{
		"COUNTRY": "KOREA, SOUTH",
		"PAESE": "COREA DEL SUD",
		"ISO_3166": "KR",
		"CODE": "+82",
		"LABEL": "KOREA, SOUTH (+82)",
		"LABEL_ITA": "COREA DEL SUD (+82)"
	},
	{
		"COUNTRY": "KUWAIT",
		"PAESE": "KUWAIT",
		"ISO_3166": "KW",
		"CODE": "+965",
		"LABEL": "KUWAIT (+965)",
		"LABEL_ITA": "KUWAIT (+965)"
	},
	{
		"COUNTRY": "KYRGYZSTAN",
		"PAESE": "KIRGHIZISTAN",
		"ISO_3166": "KG",
		"CODE": "+996",
		"LABEL": "KYRGYZSTAN (+996)",
		"LABEL_ITA": "KIRGHIZISTAN (+996)"
	},
	{
		"COUNTRY": "LAOS",
		"PAESE": "LAOS",
		"ISO_3166": "LA",
		"CODE": "+856",
		"LABEL": "LAOS (+856)",
		"LABEL_ITA": "LAOS (+856)"
	},
	{
		"COUNTRY": "LATVIA",
		"PAESE": "LETTONIA",
		"ISO_3166": "LV",
		"CODE": "+371",
		"LABEL": "LATVIA (+371)",
		"LABEL_ITA": "LETTONIA (+371)"
	},
	{
		"COUNTRY": "LEBANON",
		"PAESE": "LIBANO",
		"ISO_3166": "LB",
		"CODE": "+961",
		"LABEL": "LEBANON (+961)",
		"LABEL_ITA": "LIBANO (+961)"
	},
	{
		"COUNTRY": "LESOTHO",
		"PAESE": "LESOTHO",
		"ISO_3166": "LS",
		"CODE": "+266",
		"LABEL": "LESOTHO (+266)",
		"LABEL_ITA": "LESOTHO (+266)"
	},
	{
		"COUNTRY": "LIBERIA",
		"PAESE": "LIBERIA",
		"ISO_3166": "LR",
		"CODE": "+231",
		"LABEL": "LIBERIA (+231)",
		"LABEL_ITA": "LIBERIA (+231)"
	},
	{
		"COUNTRY": "LIBYA",
		"PAESE": "LIBIA",
		"ISO_3166": "LY",
		"CODE": "+218",
		"LABEL": "LIBYA (+218)",
		"LABEL_ITA": "LIBIA (+218)"
	},
	{
		"COUNTRY": "LIECHTENSTEIN",
		"PAESE": "LIECHTENSTEIN",
		"ISO_3166": "LI",
		"CODE": "+423",
		"LABEL": "LIECHTENSTEIN (+423)",
		"LABEL_ITA": "LIECHTENSTEIN (+423)"
	},
	{
		"COUNTRY": "LITHUANIA",
		"PAESE": "LITUANIA",
		"ISO_3166": "LT",
		"CODE": "+370",
		"LABEL": "LITHUANIA (+370)",
		"LABEL_ITA": "LITUANIA (+370)"
	},
	{
		"COUNTRY": "LUXEMBOURG",
		"PAESE": "LUSSEMBURGO",
		"ISO_3166": "LU",
		"CODE": "+352",
		"LABEL": "LUXEMBOURG (+352)",
		"LABEL_ITA": "LUSSEMBURGO (+352)"
	},
	{
		"COUNTRY": "MACAO",
		"PAESE": "MACAO",
		"ISO_3166": "MO",
		"CODE": "+853",
		"LABEL": "MACAO (+853)",
		"LABEL_ITA": "MACAO (+853)"
	},
	{
		"COUNTRY": "MACEDONIA",
		"PAESE": "MACEDONIA",
		"ISO_3166": "MK",
		"CODE": "+389",
		"LABEL": "MACEDONIA (+389)",
		"LABEL_ITA": "MACEDONIA (+389)"
	},
	{
		"COUNTRY": "MADAGASCAR",
		"PAESE": "MADAGASCAR",
		"ISO_3166": "MG",
		"CODE": "+261",
		"LABEL": "MADAGASCAR (+261)",
		"LABEL_ITA": "MADAGASCAR (+261)"
	},
	{
		"COUNTRY": "MALAWI",
		"PAESE": "MALAWI",
		"ISO_3166": "MW",
		"CODE": "+265",
		"LABEL": "MALAWI (+265)",
		"LABEL_ITA": "MALAWI (+265)"
	},
	{
		"COUNTRY": "MALAYSIA",
		"PAESE": "MALAYSIA",
		"ISO_3166": "MY",
		"CODE": "+60",
		"LABEL": "MALAYSIA (+60)",
		"LABEL_ITA": "MALAYSIA (+60)"
	},
	{
		"COUNTRY": "MALDIVES",
		"PAESE": "MALDIVE",
		"ISO_3166": "MV",
		"CODE": "+960",
		"LABEL": "MALDIVES (+960)",
		"LABEL_ITA": "MALDIVE (+960)"
	},
	{
		"COUNTRY": "MALI",
		"PAESE": "MALI",
		"ISO_3166": "ML",
		"CODE": "+223",
		"LABEL": "MALI (+223)",
		"LABEL_ITA": "MALI (+223)"
	},
	{
		"COUNTRY": "MALTA",
		"PAESE": "MALTA",
		"ISO_3166": "MT",
		"CODE": "+356",
		"LABEL": "MALTA (+356)",
		"LABEL_ITA": "MALTA (+356)"
	},
	{
		"COUNTRY": "MARSHALL ISLANDS",
		"PAESE": "MARSHALL",
		"ISO_3166": "MH",
		"CODE": "+692",
		"LABEL": "MARSHALL ISLANDS (+692)",
		"LABEL_ITA": "MARSHALL (+692)"
	},
	{
		"COUNTRY": "MARTINIQUE",
		"PAESE": "MARTINICA",
		"ISO_3166": "MQ",
		"CODE": "+596",
		"LABEL": "MARTINIQUE (+596)",
		"LABEL_ITA": "MARTINICA (+596)"
	},
	{
		"COUNTRY": "MAURITANIA",
		"PAESE": "MAURITANIA",
		"ISO_3166": "MR",
		"CODE": "+222",
		"LABEL": "MAURITANIA (+222)",
		"LABEL_ITA": "MAURITANIA (+222)"
	},
	{
		"COUNTRY": "MAURITIUS",
		"PAESE": "MAURITIUS",
		"ISO_3166": "MU",
		"CODE": "+230",
		"LABEL": "MAURITIUS (+230)",
		"LABEL_ITA": "MAURITIUS (+230)"
	},
	{
		"COUNTRY": "MAYOTTE",
		"PAESE": "MAYOTTE",
		"ISO_3166": "YT",
		"CODE": "+269",
		"LABEL": "MAYOTTE (+269)",
		"LABEL_ITA": "MAYOTTE (+269)"
	},
	{
		"COUNTRY": "MEXICO",
		"PAESE": "MESSICO",
		"ISO_3166": "MX",
		"CODE": "+52",
		"LABEL": "MEXICO (+52)",
		"LABEL_ITA": "MESSICO (+52)"
	},
	{
		"COUNTRY": "MICRONESIA",
		"PAESE": "MICRONESIA",
		"ISO_3166": "FM",
		"CODE": "+691",
		"LABEL": "MICRONESIA (+691)",
		"LABEL_ITA": "MICRONESIA (+691)"
	},
	{
		"COUNTRY": "MOLDOVA",
		"PAESE": "MOLDAVIA",
		"ISO_3166": "MD",
		"CODE": "+373",
		"LABEL": "MOLDOVA (+373)",
		"LABEL_ITA": "MOLDAVIA (+373)"
	},
	{
		"COUNTRY": "MONACO",
		"PAESE": "MONACO PRINCIPATO",
		"ISO_3166": "MC",
		"CODE": "+377",
		"LABEL": "MONACO (+377)",
		"LABEL_ITA": "MONACO PRINCIPATO (+377)"
	},
	{
		"COUNTRY": "MONGOLIA",
		"PAESE": "MONGOLIA",
		"ISO_3166": "MN",
		"CODE": "+976",
		"LABEL": "MONGOLIA (+976)",
		"LABEL_ITA": "MONGOLIA (+976)"
	},
	{
		"COUNTRY": "MONTENEGRO",
		"PAESE": "MONTENEGRO",
		"ISO_3166": "ME",
		"CODE": "+382",
		"LABEL": "MONTENEGRO (+382)",
		"LABEL_ITA": "MONTENEGRO (+382)"
	},
	{
		"COUNTRY": "MONTSERRAT",
		"PAESE": "MONSERRAT",
		"ISO_3166": "MS",
		"CODE": "+1664",
		"LABEL": "MONTSERRAT (+1664)",
		"LABEL_ITA": "MONSERRAT (+1664)"
	},
	{
		"COUNTRY": "MOROCCO",
		"PAESE": "MAROCCO",
		"ISO_3166": "MA",
		"CODE": "+212",
		"LABEL": "MOROCCO (+212)",
		"LABEL_ITA": "MAROCCO (+212)"
	},
	{
		"COUNTRY": "MOZAMBIQUE",
		"PAESE": "MOZAMBICO",
		"ISO_3166": "MZ",
		"CODE": "+258",
		"LABEL": "MOZAMBIQUE (+258)",
		"LABEL_ITA": "MOZAMBICO (+258)"
	},
	{
		"COUNTRY": "MYANMAR",
		"PAESE": "MYANMAR (BIRMANIA)",
		"ISO_3166": "MM",
		"CODE": "+95",
		"LABEL": "MYANMAR (+95)",
		"LABEL_ITA": "MYANMAR (BIRMANIA) (+95)"
	},
	{
		"COUNTRY": "NAMIBIA",
		"PAESE": "NAMIBIA",
		"ISO_3166": "NA",
		"CODE": "+264",
		"LABEL": "NAMIBIA (+264)",
		"LABEL_ITA": "NAMIBIA (+264)"
	},
	{
		"COUNTRY": "NAURU",
		"PAESE": "NAURU",
		"ISO_3166": "NR",
		"CODE": "+674",
		"LABEL": "NAURU (+674)",
		"LABEL_ITA": "NAURU (+674)"
	},
	{
		"COUNTRY": "NEPAL",
		"PAESE": "NEPAL",
		"ISO_3166": "NP",
		"CODE": "+977",
		"LABEL": "NEPAL (+977)",
		"LABEL_ITA": "NEPAL (+977)"
	},
	{
		"COUNTRY": "NETHERLANDS",
		"PAESE": "PAESI BASSI (OLANDA)",
		"ISO_3166": "NL",
		"CODE": "+31",
		"LABEL": "NETHERLANDS (+31)",
		"LABEL_ITA": "PAESI BASSI (OLANDA) (+31)"
	},
	{
		"COUNTRY": "NETHERLANDS ANTILLES",
		"PAESE": "ANTILLE OLANDESI",
		"ISO_3166": "AN",
		"CODE": "+599",
		"LABEL": "NETHERLANDS ANTILLES (+599)",
		"LABEL_ITA": "ANTILLE OLANDESI (+599)"
	},
	{
		"COUNTRY": "NEW CALEDONIA",
		"PAESE": "NUOVA CALEDONIA",
		"ISO_3166": "NC",
		"CODE": "+687",
		"LABEL": "NEW CALEDONIA (+687)",
		"LABEL_ITA": "NUOVA CALEDONIA (+687)"
	},
	{
		"COUNTRY": "NEW ZEALAND",
		"PAESE": "NUOVA ZELANDA",
		"ISO_3166": "NZ",
		"CODE": "+64",
		"LABEL": "NEW ZEALAND (+64)",
		"LABEL_ITA": "NUOVA ZELANDA (+64)"
	},
	{
		"COUNTRY": "NICARAGUA",
		"PAESE": "NICARAGUA",
		"ISO_3166": "NI",
		"CODE": "+505",
		"LABEL": "NICARAGUA (+505)",
		"LABEL_ITA": "NICARAGUA (+505)"
	},
	{
		"COUNTRY": "NIGER",
		"PAESE": "NIGER",
		"ISO_3166": "NE",
		"CODE": "+227",
		"LABEL": "NIGER (+227)",
		"LABEL_ITA": "NIGER (+227)"
	},
	{
		"COUNTRY": "NIGERIA",
		"PAESE": "NIGERIA",
		"ISO_3166": "NG",
		"CODE": "+234",
		"LABEL": "NIGERIA (+234)",
		"LABEL_ITA": "NIGERIA (+234)"
	},
	{
		"COUNTRY": "NIUE",
		"PAESE": "NIUE",
		"ISO_3166": "NU",
		"CODE": "+683",
		"LABEL": "NIUE (+683)",
		"LABEL_ITA": "NIUE (+683)"
	},
	{
		"COUNTRY": "NORFOLK ISLAND",
		"PAESE": "NORFOLK",
		"ISO_3166": "NF",
		"CODE": "+672",
		"LABEL": "NORFOLK ISLAND (+672)",
		"LABEL_ITA": "NORFOLK (+672)"
	},
	{
		"COUNTRY": "NORTHERN MARIANA ISLANDS",
		"PAESE": "MARIANNE",
		"ISO_3166": "MP",
		"CODE": "+16",
		"LABEL": "NORTHERN MARIANA ISLANDS (+16)",
		"LABEL_ITA": "MARIANNE (+16)"
	},
	{
		"COUNTRY": "NORWAY",
		"PAESE": "NORVEGIA",
		"ISO_3166": "NO",
		"CODE": "+47",
		"LABEL": "NORWAY (+47)",
		"LABEL_ITA": "NORVEGIA (+47)"
	},
	{
		"COUNTRY": "OMAN",
		"PAESE": "OMAN",
		"ISO_3166": "OM",
		"CODE": "+968",
		"LABEL": "OMAN (+968)",
		"LABEL_ITA": "OMAN (+968)"
	},
	{
		"COUNTRY": "PAKISTAN",
		"PAESE": "PAKISTAN",
		"ISO_3166": "PK",
		"CODE": "+92",
		"LABEL": "PAKISTAN (+92)",
		"LABEL_ITA": "PAKISTAN (+92)"
	},
	{
		"COUNTRY": "PALAU",
		"PAESE": "PALAU",
		"ISO_3166": "PW",
		"CODE": "+680",
		"LABEL": "PALAU (+680)",
		"LABEL_ITA": "PALAU (+680)"
	},
	{
		"COUNTRY": "PALESTINIAN TERRITORY, OCCUPIED",
		"PAESE": "PALESTINA",
		"ISO_3166": "PS",
		"CODE": "+970",
		"LABEL": "PALESTINIAN TERRITORY, OCCUPIED (+970)",
		"LABEL_ITA": "PALESTINA (+970)"
	},
	{
		"COUNTRY": "PANAMA",
		"PAESE": "PANAMA",
		"ISO_3166": "PA",
		"CODE": "+507",
		"LABEL": "PANAMA (+507)",
		"LABEL_ITA": "PANAMA (+507)"
	},
	{
		"COUNTRY": "PAPUA NEW GUINEA",
		"PAESE": "PAPUA NUOVA GUINEA",
		"ISO_3166": "PG",
		"CODE": "+675",
		"LABEL": "PAPUA NEW GUINEA (+675)",
		"LABEL_ITA": "PAPUA NUOVA GUINEA (+675)"
	},
	{
		"COUNTRY": "PARAGUAY",
		"PAESE": "PARAGUAY",
		"ISO_3166": "PY",
		"CODE": "+595",
		"LABEL": "PARAGUAY (+595)",
		"LABEL_ITA": "PARAGUAY (+595)"
	},
	{
		"COUNTRY": "PERU",
		"PAESE": "PERU'",
		"ISO_3166": "PE",
		"CODE": "+51",
		"LABEL": "PERU (+51)",
		"LABEL_ITA": "PERU' (+51)"
	},
	{
		"COUNTRY": "PHILIPPINES",
		"PAESE": "FILIPPINE",
		"ISO_3166": "PH",
		"CODE": "+63",
		"LABEL": "PHILIPPINES (+63)",
		"LABEL_ITA": "FILIPPINE (+63)"
	},
	{
		"COUNTRY": "PITCAIRN",
		"PAESE": "PITCAIRN",
		"ISO_3166": "PN",
		"CODE": "+872",
		"LABEL": "PITCAIRN (+872)",
		"LABEL_ITA": "PITCAIRN (+872)"
	},
	{
		"COUNTRY": "POLAND",
		"PAESE": "POLONIA",
		"ISO_3166": "PL",
		"CODE": "+48",
		"LABEL": "POLAND (+48)",
		"LABEL_ITA": "POLONIA (+48)"
	},
	{
		"COUNTRY": "PORTUGAL",
		"PAESE": "PORTOGALLO",
		"ISO_3166": "PT",
		"CODE": "+351",
		"LABEL": "PORTUGAL (+351)",
		"LABEL_ITA": "PORTOGALLO (+351)"
	},
	{
		"COUNTRY": "PUERTO RICO",
		"PAESE": "PORTORICO",
		"ISO_3166": "PR",
		"CODE": "+1787",
		"LABEL": "PUERTO RICO (+1787)",
		"LABEL_ITA": "PORTORICO (+1787)"
	},
	{
		"COUNTRY": "QATAR",
		"PAESE": "QATAR",
		"ISO_3166": "QA",
		"CODE": "+974",
		"LABEL": "QATAR (+974)",
		"LABEL_ITA": "QATAR (+974)"
	},
	{
		"COUNTRY": "REPUBLIC OF THE CONGO (ZAIRE)",
		"PAESE": "REPUBBLICA DEMOCRATICA DEL CONGO (ZAIRE)",
		"ISO_3166": "CD",
		"CODE": "+243",
		"LABEL": "REPUBLIC OF THE CONGO (ZAIRE) (+243)",
		"LABEL_ITA": "REPUBBLICA DEMOCRATICA DEL CONGO (ZAIRE) (+243)"
	},
	{
		"COUNTRY": "ROMANIA",
		"PAESE": "ROMANIA",
		"ISO_3166": "RO",
		"CODE": "+40",
		"LABEL": "ROMANIA (+40)",
		"LABEL_ITA": "ROMANIA (+40)"
	},
	{
		"COUNTRY": "RUSSIA",
		"PAESE": "RUSSIA",
		"ISO_3166": "RU",
		"CODE": "+7",
		"LABEL": "RUSSIA (+7)",
		"LABEL_ITA": "RUSSIA (+7)"
	},
	{
		"COUNTRY": "RWANDA",
		"PAESE": "RUANDA",
		"ISO_3166": "RW",
		"CODE": "+250",
		"LABEL": "RWANDA (+250)",
		"LABEL_ITA": "RUANDA (+250)"
	},
	{
		"COUNTRY": "RÉUNION",
		"PAESE": "REUNIONE",
		"ISO_3166": "RE",
		"CODE": "+262",
		"LABEL": "RÉUNION (+262)",
		"LABEL_ITA": "REUNIONE (+262)"
	},
	{
		"COUNTRY": "SAINT HELENA",
		"PAESE": "SANT'ELENA",
		"ISO_3166": "SH",
		"CODE": "+290",
		"LABEL": "SAINT HELENA (+290)",
		"LABEL_ITA": "SANT'ELENA (+290)"
	},
	{
		"COUNTRY": "SAINT KITTS AND NEVIS",
		"PAESE": "SAINT KITTIS E NEVIS",
		"ISO_3166": "KN",
		"CODE": "+1869",
		"LABEL": "SAINT KITTS AND NEVIS (+1869)",
		"LABEL_ITA": "SAINT KITTIS E NEVIS (+1869)"
	},
	{
		"COUNTRY": "SAINT LUCIA",
		"PAESE": "SAINT LUCIA",
		"ISO_3166": "LC",
		"CODE": "+17",
		"LABEL": "SAINT LUCIA (+17)",
		"LABEL_ITA": "SAINT LUCIA (+17)"
	},
	{
		"COUNTRY": "SAINT PIERRE AND MIQUELON",
		"PAESE": "SAINT PIERRE E MIQUELON",
		"ISO_3166": "PM",
		"CODE": "+508",
		"LABEL": "SAINT PIERRE AND MIQUELON (+508)",
		"LABEL_ITA": "SAINT PIERRE E MIQUELON (+508)"
	},
	{
		"COUNTRY": "SAINT VINCENT",
		"PAESE": "SAINT VINCENT E GRENADINE",
		"ISO_3166": "VC",
		"CODE": "+1784",
		"LABEL": "SAINT VINCENT (+1784)",
		"LABEL_ITA": "SAINT VINCENT E GRENADINE (+1784)"
	},
	{
		"COUNTRY": "SAMOA",
		"PAESE": "SAMOA",
		"ISO_3166": "WS",
		"CODE": "+685",
		"LABEL": "SAMOA (+685)",
		"LABEL_ITA": "SAMOA (+685)"
	},
	{
		"COUNTRY": "SAN MARINO",
		"PAESE": "SAN MARINO",
		"ISO_3166": "SM",
		"CODE": "+378",
		"LABEL": "SAN MARINO (+378)",
		"LABEL_ITA": "SAN MARINO (+378)"
	},
	{
		"COUNTRY": "SAO TOME AND PRINCIPE",
		"PAESE": "SAO TOME' E PRINCIPE",
		"ISO_3166": "ST",
		"CODE": "+239",
		"LABEL": "SAO TOME AND PRINCIPE (+239)",
		"LABEL_ITA": "SAO TOME' E PRINCIPE (+239)"
	},
	{
		"COUNTRY": "SAUDI ARABIA",
		"PAESE": "ARABIA SAUDITA",
		"ISO_3166": "SA",
		"CODE": "+966",
		"LABEL": "SAUDI ARABIA (+966)",
		"LABEL_ITA": "ARABIA SAUDITA (+966)"
	},
	{
		"COUNTRY": "SENEGAL",
		"PAESE": "SENEGAL",
		"ISO_3166": "SN",
		"CODE": "+221",
		"LABEL": "SENEGAL (+221)",
		"LABEL_ITA": "SENEGAL (+221)"
	},
	{
		"COUNTRY": "SERBIA",
		"PAESE": "SERBIA",
		"ISO_3166": "RS",
		"CODE": "+381",
		"LABEL": "SERBIA (+381)",
		"LABEL_ITA": "SERBIA (+381)"
	},
	{
		"COUNTRY": "SEYCHELLES",
		"PAESE": "SEYCHELLES",
		"ISO_3166": "SC",
		"CODE": "+248",
		"LABEL": "SEYCHELLES (+248)",
		"LABEL_ITA": "SEYCHELLES (+248)"
	},
	{
		"COUNTRY": "SIERRA LEONE",
		"PAESE": "SIERRA LEONE",
		"ISO_3166": "SL",
		"CODE": "+232",
		"LABEL": "SIERRA LEONE (+232)",
		"LABEL_ITA": "SIERRA LEONE (+232)"
	},
	{
		"COUNTRY": "SINGAPORE",
		"PAESE": "SINGAPORE",
		"ISO_3166": "SG",
		"CODE": "+65",
		"LABEL": "SINGAPORE (+65)",
		"LABEL_ITA": "SINGAPORE (+65)"
	},
	{
		"COUNTRY": "SLOVAKIA",
		"PAESE": "SLOVACCA REPUBBLICA",
		"ISO_3166": "SK",
		"CODE": "+421",
		"LABEL": "SLOVAKIA (+421)",
		"LABEL_ITA": "SLOVACCA REPUBBLICA (+421)"
	},
	{
		"COUNTRY": "SLOVENIA",
		"PAESE": "SLOVENIA",
		"ISO_3166": "SI",
		"CODE": "+386",
		"LABEL": "SLOVENIA (+386)",
		"LABEL_ITA": "SLOVENIA (+386)"
	},
	{
		"COUNTRY": "SOLOMON ISLANDS",
		"PAESE": "SALOMONE",
		"ISO_3166": "SB",
		"CODE": "+677",
		"LABEL": "SOLOMON ISLANDS (+677)",
		"LABEL_ITA": "SALOMONE (+677)"
	},
	{
		"COUNTRY": "SOMALIA",
		"PAESE": "SOMALIA",
		"ISO_3166": "SO",
		"CODE": "+252",
		"LABEL": "SOMALIA (+252)",
		"LABEL_ITA": "SOMALIA (+252)"
	},
	{
		"COUNTRY": "SOUTH AFRICA",
		"PAESE": "SUD AFRICA",
		"ISO_3166": "ZA",
		"CODE": "+27",
		"LABEL": "SOUTH AFRICA (+27)",
		"LABEL_ITA": "SUD AFRICA (+27)"
	},
	{
		"COUNTRY": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS",
		"PAESE": "GEORGIA DEL SUD E ISOLE SANDWICH AUSTRALI",
		"ISO_3166": "GS",
		"CODE": "+500",
		"LABEL": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS (+500)",
		"LABEL_ITA": "GEORGIA DEL SUD E ISOLE SANDWICH AUSTRALI (+500)"
	},
	{
		"COUNTRY": "SPAIN",
		"PAESE": "SPAGNA",
		"ISO_3166": "ES",
		"CODE": "+34",
		"LABEL": "SPAIN (+34)",
		"LABEL_ITA": "SPAGNA (+34)"
	},
	{
		"COUNTRY": "SRI LANKA",
		"PAESE": "SRI LANKA",
		"ISO_3166": "LK",
		"CODE": "+94",
		"LABEL": "SRI LANKA (+94)",
		"LABEL_ITA": "SRI LANKA (+94)"
	},
	{
		"COUNTRY": "SUDAN",
		"PAESE": "SUDAN",
		"ISO_3166": "SD",
		"CODE": "+249",
		"LABEL": "SUDAN (+249)",
		"LABEL_ITA": "SUDAN (+249)"
	},
	{
		"COUNTRY": "SURINAME",
		"PAESE": "SURINAME",
		"ISO_3166": "SR",
		"CODE": "+597",
		"LABEL": "SURINAME (+597)",
		"LABEL_ITA": "SURINAME (+597)"
	},
	{
		"COUNTRY": "SVALBARD AND JAN MAYEN",
		"PAESE": "SVALBARD E JAN MAYEN",
		"ISO_3166": "SJ",
		"CODE": "+47",
		"LABEL": "SVALBARD AND JAN MAYEN (+47)",
		"LABEL_ITA": "SVALBARD E JAN MAYEN (+47)"
	},
	{
		"COUNTRY": "SWAZILAND",
		"PAESE": "SWAZILAND",
		"ISO_3166": "SZ",
		"CODE": "+268",
		"LABEL": "SWAZILAND (+268)",
		"LABEL_ITA": "SWAZILAND (+268)"
	},
	{
		"COUNTRY": "SWEDEN",
		"PAESE": "SVEZIA",
		"ISO_3166": "SE",
		"CODE": "+46",
		"LABEL": "SWEDEN (+46)",
		"LABEL_ITA": "SVEZIA (+46)"
	},
	{
		"COUNTRY": "SWITZERLAND",
		"PAESE": "SVIZZERA",
		"ISO_3166": "CH",
		"CODE": "+41",
		"LABEL": "SWITZERLAND (+41)",
		"LABEL_ITA": "SVIZZERA (+41)"
	},
	{
		"COUNTRY": "SYRIA",
		"PAESE": "SIRIA",
		"ISO_3166": "SY",
		"CODE": "+963",
		"LABEL": "SYRIA (+963)",
		"LABEL_ITA": "SIRIA (+963)"
	},
	{
		"COUNTRY": "TAIWAN",
		"PAESE": "TAIWAN",
		"ISO_3166": "TW",
		"CODE": "+886",
		"LABEL": "TAIWAN (+886)",
		"LABEL_ITA": "TAIWAN (+886)"
	},
	{
		"COUNTRY": "TAJIKISTAN",
		"PAESE": "TAGIKISTAN",
		"ISO_3166": "TJ",
		"CODE": "+7",
		"LABEL": "TAJIKISTAN (+7)",
		"LABEL_ITA": "TAGIKISTAN (+7)"
	},
	{
		"COUNTRY": "TANZANIA",
		"PAESE": "TANZANIA",
		"ISO_3166": "TZ",
		"CODE": "+255",
		"LABEL": "TANZANIA (+255)",
		"LABEL_ITA": "TANZANIA (+255)"
	},
	{
		"COUNTRY": "THAILAND",
		"PAESE": "THAILANDIA",
		"ISO_3166": "TH",
		"CODE": "+66",
		"LABEL": "THAILAND (+66)",
		"LABEL_ITA": "THAILANDIA (+66)"
	},
	{
		"COUNTRY": "TIMOR-LESTE",
		"PAESE": "TIMOR EST",
		"ISO_3166": "TL",
		"CODE": "+670",
		"LABEL": "TIMOR-LESTE (+670)",
		"LABEL_ITA": "TIMOR EST (+670)"
	},
	{
		"COUNTRY": "TOGO",
		"PAESE": "TOGO",
		"ISO_3166": "TG",
		"CODE": "+228",
		"LABEL": "TOGO (+228)",
		"LABEL_ITA": "TOGO (+228)"
	},
	{
		"COUNTRY": "TOKELAU",
		"PAESE": "TOKELAU",
		"ISO_3166": "TK",
		"CODE": "+690",
		"LABEL": "TOKELAU (+690)",
		"LABEL_ITA": "TOKELAU (+690)"
	},
	{
		"COUNTRY": "TONGA",
		"PAESE": "TONGA",
		"ISO_3166": "TO",
		"CODE": "+676",
		"LABEL": "TONGA (+676)",
		"LABEL_ITA": "TONGA (+676)"
	},
	{
		"COUNTRY": "TRINIDAD",
		"PAESE": "TRINIDAD E TOBAGO",
		"ISO_3166": "TT",
		"CODE": "+1868",
		"LABEL": "TRINIDAD (+1868)",
		"LABEL_ITA": "TRINIDAD E TOBAGO (+1868)"
	},
	{
		"COUNTRY": "TUNISIA",
		"PAESE": "TUNISIA",
		"ISO_3166": "TN",
		"CODE": "+216",
		"LABEL": "TUNISIA (+216)",
		"LABEL_ITA": "TUNISIA (+216)"
	},
	{
		"COUNTRY": "TURKEY",
		"PAESE": "TURCHIA",
		"ISO_3166": "TR",
		"CODE": "+90",
		"LABEL": "TURKEY (+90)",
		"LABEL_ITA": "TURCHIA (+90)"
	},
	{
		"COUNTRY": "TURKMENISTAN",
		"PAESE": "TURKMENISTAN",
		"ISO_3166": "TM",
		"CODE": "+993",
		"LABEL": "TURKMENISTAN (+993)",
		"LABEL_ITA": "TURKMENISTAN (+993)"
	},
	{
		"COUNTRY": "TURKS AND CAICOS ISLANDS",
		"PAESE": "TURKS E CAICOS",
		"ISO_3166": "TC",
		"CODE": "+1649",
		"LABEL": "TURKS AND CAICOS ISLANDS (+1649)",
		"LABEL_ITA": "TURKS E CAICOS (+1649)"
	},
	{
		"COUNTRY": "TUVALU",
		"PAESE": "TUVALU",
		"ISO_3166": "TV",
		"CODE": "+688",
		"LABEL": "TUVALU (+688)",
		"LABEL_ITA": "TUVALU (+688)"
	},
	{
		"COUNTRY": "UGANDA",
		"PAESE": "UGANDA",
		"ISO_3166": "UG",
		"CODE": "+256",
		"LABEL": "UGANDA (+256)",
		"LABEL_ITA": "UGANDA (+256)"
	},
	{
		"COUNTRY": "UKRAINE",
		"PAESE": "UCRAINA",
		"ISO_3166": "UA",
		"CODE": "+380",
		"LABEL": "UKRAINE (+380)",
		"LABEL_ITA": "UCRAINA (+380)"
	},
	{
		"COUNTRY": "UNITED ARAB EMIRATES",
		"PAESE": "EMIRATI ARABI UNITI",
		"ISO_3166": "AE",
		"CODE": "+971",
		"LABEL": "UNITED ARAB EMIRATES (+971)",
		"LABEL_ITA": "EMIRATI ARABI UNITI (+971)"
	},
	{
		"COUNTRY": "UNITED KINGDOM",
		"PAESE": "REGNO UNITO",
		"ISO_3166": "GB",
		"CODE": "+44",
		"LABEL": "UNITED KINGDOM (+44)",
		"LABEL_ITA": "REGNO UNITO (+44)"
	},
	{
		"COUNTRY": "UNITED STATES",
		"PAESE": "USA",
		"ISO_3166": "US",
		"CODE": "+1",
		"LABEL": "UNITED STATES (+1)",
		"LABEL_ITA": "USA (+1)"
	},
	{
		"COUNTRY": "UNITED STATES MINOR OUTLYING ISLANDS",
		"PAESE": "ISOLE MINORI ESTERNE DEGLI STATI UNITI D'AMERICA",
		"ISO_3166": "UM",
		"CODE": "+699",
		"LABEL": "UNITED STATES MINOR OUTLYING ISLANDS (+699)",
		"LABEL_ITA": "ISOLE MINORI ESTERNE DEGLI STATI UNITI D'AMERICA (+699)"
	},
	{
		"COUNTRY": "URUGUAY",
		"PAESE": "URUGUAY",
		"ISO_3166": "UY",
		"CODE": "+598",
		"LABEL": "URUGUAY (+598)",
		"LABEL_ITA": "URUGUAY (+598)"
	},
	{
		"COUNTRY": "UZBEKISTAN",
		"PAESE": "UZBEKISTAN",
		"ISO_3166": "UZ",
		"CODE": "+998",
		"LABEL": "UZBEKISTAN (+998)",
		"LABEL_ITA": "UZBEKISTAN (+998)"
	},
	{
		"COUNTRY": "VANUATU",
		"PAESE": "VANUATU",
		"ISO_3166": "VU",
		"CODE": "+678",
		"LABEL": "VANUATU (+678)",
		"LABEL_ITA": "VANUATU (+678)"
	},
	{
		"COUNTRY": "VENEZUELA",
		"PAESE": "VENEZUELA",
		"ISO_3166": "VE",
		"CODE": "+58",
		"LABEL": "VENEZUELA (+58)",
		"LABEL_ITA": "VENEZUELA (+58)"
	},
	{
		"COUNTRY": "VIETNAM",
		"PAESE": "VIETNAM",
		"ISO_3166": "VN",
		"CODE": "+84",
		"LABEL": "VIETNAM (+84)",
		"LABEL_ITA": "VIETNAM (+84)"
	},
	{
		"COUNTRY": "VIRGIN ISLANDS, BRITISH",
		"PAESE": "VERGINI IS. BRITANNICHE",
		"ISO_3166": "VG",
		"CODE": "+1284",
		"LABEL": "VIRGIN ISLANDS, BRITISH (+1284)",
		"LABEL_ITA": "VERGINI IS. BRITANNICHE (+1284)"
	},
	{
		"COUNTRY": "VIRGIN ISLANDS, U.S.",
		"PAESE": "VERGINI IS. AMERICANE",
		"ISO_3166": "VI",
		"CODE": "+1340",
		"LABEL": "VIRGIN ISLANDS, U.S. (+1340)",
		"LABEL_ITA": "VERGINI IS. AMERICANE (+1340)"
	},
	{
		"COUNTRY": "WAKE",
		"PAESE": "WAKE",
		"ISO_3166": "WK",
		"CODE": "+18",
		"LABEL": "WAKE (+18)",
		"LABEL_ITA": "WAKE (+18)"
	},
	{
		"COUNTRY": "WALLIS AND FUTUNA",
		"PAESE": "WALLIS E FUTUNA",
		"ISO_3166": "WF",
		"CODE": "+681",
		"LABEL": "WALLIS AND FUTUNA (+681)",
		"LABEL_ITA": "WALLIS E FUTUNA (+681)"
	},
	{
		"COUNTRY": "WESTERN SAHARA",
		"PAESE": "SAHARA OCCIDENTALE",
		"ISO_3166": "EH",
		"CODE": "+212",
		"LABEL": "WESTERN SAHARA (+212)",
		"LABEL_ITA": "SAHARA OCCIDENTALE (+212)"
	},
	{
		"COUNTRY": "YEMEN",
		"PAESE": "YEMEN",
		"ISO_3166": "YE",
		"CODE": "+967",
		"LABEL": "YEMEN (+967)",
		"LABEL_ITA": "YEMEN (+967)"
	},
	{
		"COUNTRY": "ZAMBIA",
		"PAESE": "ZAMBIA",
		"ISO_3166": "ZM",
		"CODE": "+260",
		"LABEL": "ZAMBIA (+260)",
		"LABEL_ITA": "ZAMBIA (+260)"
	},
	{
		"COUNTRY": "ZIMBABWE",
		"PAESE": "ZIMBABWE",
		"ISO_3166": "ZW",
		"CODE": "+263",
		"LABEL": "ZIMBABWE (+263)",
		"LABEL_ITA": "ZIMBABWE (+263)"
	},
	{
		"COUNTRY": "ÅLAND ISLANDS",
		"PAESE": "ISOLE ÅLAND",
		"ISO_3166": "AX",
		"CODE": "+358",
		"LABEL": "ÅLAND ISLANDS (+358)",
		"LABEL_ITA": "ISOLE ÅLAND (+358)"
	}
];
